import React from "react";
import { Link } from "react-router-dom";

const Privacy: React.FC = () => (
  <main className="min-h-screen bg-slate-50 px-4 py-10 text-slate-800 sm:px-6">
    <article className="mx-auto max-w-3xl overflow-hidden rounded-2xl bg-white shadow-sm ring-1 ring-slate-200">
      <header className="bg-gradient-to-r from-blue-800 to-cyan-600 px-6 py-8 text-white sm:px-10">
        <img
          src="/vodovod-doboj-logo.png"
          alt="Vodovod Doboj"
          className="mb-6 h-14 w-auto max-w-full rounded bg-white p-2 object-contain"
        />
        <h1 className="text-3xl font-bold">Politika privatnosti</h1>
        <p className="mt-2 text-blue-50">Moj Vodovod Doboj</p>
      </header>

      <div className="space-y-8 px-6 py-8 leading-7 sm:px-10">
        <section>
          <h2 className="mb-2 text-xl font-semibold">Koje podatke obrađujemo</h2>
          <p>
            Aplikacija obrađuje podatke potrebne za pružanje vodovodnih usluga:
            ime i prezime, email adresu, broj telefona, podatke o korisničkom
            nalogu i vodomjeru, očitanja, račune, prijave kvarova i odabrane
            postavke obavještenja.
          </p>
        </section>

        <section>
          <h2 className="mb-2 text-xl font-semibold">Zašto koristimo podatke</h2>
          <p>
            Podatke koristimo isključivo za provjeru i upravljanje korisničkim
            nalogom, prikaz pripadajućih vodomjera, očitanja i računa, slanje
            servisnih obavještenja, obradu prijava kvarova i podršku korisnicima.
            Podatke ne prodajemo i ne koristimo za oglašavanje.
          </p>
        </section>

        <section>
          <h2 className="mb-2 text-xl font-semibold">Dijeljenje i čuvanje</h2>
          <p>
            Pristup podacima imaju samo ovlašteni zaposleni Vodovoda Doboj i
            tehnički pružaoci usluga koji održavaju sistem. Podaci se čuvaju
            koliko je potrebno za pružanje usluge, ispunjavanje zakonskih
            obaveza i rješavanje korisničkih zahtjeva, uz odgovarajuće tehničke
            i organizacione mjere zaštite.
          </p>
        </section>

        <section>
          <h2 className="mb-2 text-xl font-semibold">Vaša prava</h2>
          <p>
            Možete zatražiti pristup, ispravku ili brisanje podataka, ograničenje
            obrade i informacije o svom nalogu. Za brisanje naloga pogledajte
            stranicu <Link className="font-semibold text-blue-700 underline" to="/account-deletion">Brisanje naloga</Link>.
          </p>
        </section>

        <section>
          <h2 className="mb-2 text-xl font-semibold">Kontakt</h2>
          <p>
            Za pitanja o privatnosti pišite na{" "}
            <a className="font-semibold text-blue-700 underline" href="mailto:info@vodovod-doboj.com">
              info@vodovod-doboj.com
            </a>.
          </p>
        </section>

        <p className="border-t border-slate-200 pt-6 text-sm text-slate-500">
          Posljednje ažuriranje: 12. august 2026.
        </p>
      </div>
    </article>
  </main>
);

export default Privacy;
